import Vue from 'vue'
import App from './App.vue'
import router from './router';
import './assets/all.css'
import ElementUI, { Loading } from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'  //英文包
import 'element-ui/lib/theme-chalk/index.css'
import './assets/cross-icon/iconfont.css'
import store from './store'
import axios from './requests/index.js'
import single from "./assets/js/single";
import md5 from 'md5'
import qs from 'querystring'
import sortable from 'sortablejs'
import JsZip from 'jszip'
store.commit('modifyData', { name: 'allDom', newdata: single.getPageData(router) })  //初始化页面节点


// 公用组件注册
Vue.component('page-editer',re => require(['./components/EditerTemplate.vue'],re))
// 载入语言
{
  let language = require('./assets/json/language.json')
  let type = localStorage.language || 'English'
  store.commit('modifyData', { name: 'language', newdata: language[type] })
}

Vue.use(ElementUI, { locale })

Object.keys(axios).some((item) => { Vue.prototype['$' + item] = axios[item] })

Vue.prototype.$loading = Loading
Vue.prototype.$JsZip = JsZip
Vue.prototype.$sortable = sortable
Vue.prototype.$savePagination= (key,obj) => {
  localStorage.setItem(key,JSON.stringify(obj))
}
Vue.prototype.$getPagination = (key) => {
  return localStorage.getItem(key)
}
Vue.prototype.$uploadFile = (file,func) => {
  let src = ''
  // 上传
  let formData = new FormData();
  formData.append("file", file);
  axios.request('/manage/file/upload',formData,res => {
    if(res.data.code === 200){
      func(res.data.data.fileRelativeUrl)
    }
  },'post',true)
  // src = URL.createObjectURL(file);
  func(src)
}
Vue.use(ElementUI)

// 对象深复制
function $deepCopy(data) {
  if (!data && (data != false) && (data != 0)) { throw `数据为空 => ${data}` }
  let container = null;
  if (data.constructor === Array) {
    container = []
    data.some((item, index) => {
      if (typeof item === 'object') {
        container[index] = $deepCopy(item)
      } else {
        container[index] = item
      }
    })
  }
  if (data.constructor === Object) {
    container = {}
    Object.keys(data).some((item) => {
      if (typeof data[item] === 'object' && data[item] != null) {
        container[item] = $deepCopy(data[item])
      } else {
        container[item] = data[item]
      }
    })
  }
  if (data.constructor != Object && data.constructor != Array) {
    container = data
  }
  return container
}
// Object.prototype.length = function(){ return Object.keys(this).length }
Vue.prototype.$md5 = md5
Vue.prototype.$qs = qs
Vue.prototype.$loading = ElementUI.Loading
Vue.prototype.$deepCopy = $deepCopy
Vue.prototype.$cutArray = (array, Index) => {
  const newData = []
  array.some((item, index) => {
    if (index === Index) { return false }
    newData.push(item)
  })
  return newData
}

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // 刷新manage清缓存
  if (to.path === '/project-manage' || to.path === '/template-manage') {
    if (from.path.indexOf(to.path) === -1) {
      let head = to.path.slice(1, to.path.indexOf('-'))
      localStorage.removeItem(`pageSearchData_${head}`)
      let head2 = head[0].toUpperCase() + head.slice(1, head.length)
      localStorage.removeItem(`pageNum${head2}`)
    }
  }
  // main
  let localStorageToken = localStorage.getItem('token')
  // 没有token时允许访问
  let allowArray = ['/login']
  let a = false
  allowArray.some(item => {
    if (to.path === item) {
      a = true
      return true
    }
  })
  if (a) { return next() }
  if (store.state.token || localStorageToken) {
    return next()
  } else {
    next('/login')
  }
})

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
